import React, { Component } from 'react';
import FormClient from '../sales/FormClient';
import FormReturnSale from './FormReturnSale';

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableRow, TableCell, TableBody, IconButton } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import {  toast } from 'react-toastify';
import ProductLineCell from '../containers/ProductLineCell';

const translate = {
    "new": "Comme Neuf",
    "very_good": "Très bien",
    "good": "Bien",
    "bad": "Mauvais",
}

const initErrors = {
    shop: "",
    shop_dest: "",
    cli_type: "",
    quantity: "",
    nature:"",
    transport:"",
    discount:"",
    taxes:"",
    products:[
        {
            return_product_id:"",
            product_ref:"",
            quantity:"",
            priceR:"",
            priceTotal:"",
            priceTotal:"",
        }
    ],
}

const initSale = {
    shop: "",
    client_ref: "",
    sale_paygo_id: "",
    cli_type: "",
    cli_typeDisplay:{},
    shopDisplay:{},
    shopDestDisplay:{},
    natureDisplay:{},
    nature:"",
    transport:0,
    taxes:0,            
    comments:"",
    discount:0,
    total:0,
    products:[
        {
            display:{value:"", label:""},
            product_ref:"",
            return_product_id:"",
            quantity:"",
            max:"",
            price:"",
            priceR:"",
            priceTotal:"",
        }
    ],
}

const initClient = {
    client_lastname:"",
    client_firstname:"",
    client_address:"",
    client_tel:"",
    client_email:"",
    client_city:"",
    client_country:"",
    client_paygo_id:"",
}

class Form extends Component {
    state = { 
        sale: initSale,
        errors: initErrors,
        client: initClient,
        errorsClient: initClient,
        view: "sale",
        numberProd:1,

    }
    componentDidMount() {
        // this.props.getAllReturnStocks()
    }
    handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        if(name === "nature"){
            console.log("change nature");
            
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    transport:0,
                    taxes:0,
                    [name]:value,
                    [displayName]:option
                }
            })
        } else if(name === "shop"){
            console.log("change shop");
            
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            return_product_id:"",
                            product_ref:"",
                            quantity:"",
                            max:"",
                            price:"",
                            priceR:"",
                            priceTotal:"",
                        }
                    ],
                },
                numberProd:1
            })
            this.createAddForm()
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option
                }
            })
        }        
    }
    handleSelectProducts = (option, index) => { 
        console.log("SELECT HANDLE",{option, index});

        let value = option.value
        const product = this.props.RETURNS[value]
        const max = this.props.OCCASION[value].quantity    

        let cpProducts = this.state.sale.products
        cpProducts[index].return_product_id = value
        cpProducts[index].product_ref = product.product_ref
        cpProducts[index].product_id = product.product_ref
        // cpProducts[index].quantity = 0
        cpProducts[index].max = max
        cpProducts[index].price =  product.sell_price
        cpProducts[index].priceR =  product.sell_price
        cpProducts[index].priceTotal = ( product.sell_price * (cpProducts[index].quantity || 0)  )
        cpProducts[index].display = option
        
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:cpProducts,
            }
        })        
    }
    
    createProductList = () => {
        // console.log("CREATE PRODUCT LIST");
        const list = [{value:"", label:"Chosissez un Produit"}]
        const  { RETURNS, PRODUCTS, OCCASION } = this.props

        console.log('====================================');
        console.log({ RETURNS, PRODUCTS, OCCASION });
        console.log('====================================');
        if(!isEmpty(RETURNS) && !isEmpty(OCCASION)){
            Object.values(RETURNS).map( returnProd => {   
                let selected = false
                let currentProd = PRODUCTS[returnProd.product_ref]
                let stock = OCCASION[returnProd.id]
                this.state.sale.products.map( prod => {   
                    if( prod.return_product_id  === returnProd.id)   {  // already selected   
                        selected = true 
                    } 
                })
                if( stock && stock.shop_id === this.state.sale.shop && stock.quantity > 0 ){
                    list.push (       
                        { 
                            value: returnProd.id, 
                            ref: currentProd.id,
                            label: `${currentProd.marque} - ${currentProd.name} - ${translate[returnProd.product_state]} - ${returnProd.id.substring(0,8)}`, 
                            disabled:selected 
                        } 
                    )
                }
            })
        }
        return list
    }
    createAddForm = () => {
        const tab = []
        const products = this.createProductList()

        console.log('=================createAddForm===================');
        console.log({products});
        console.log('====================================');
        // console.log("[INFO] CREATE ADD FORM INDEX ");
        for (let i = 0; i < this.state.numberProd;i++) {
            
            tab.push(
                <TableRow key={i}>             
                    {/* <TableCell style={{ minWidth: "450px"}}>
                        {i !== 0 &&
                        <IconButton 
                            type="button" 
                            className="delete-line" 
                            onClick={()=>this.handleDeleteProd(i)}
                            
                        >
                            <CloseRounded color="error" />
                        </IconButton>
                        }
                        <InputSelectMagasin
                            options={products}
                            value={this.state.sale.products[i].display}
                            label="Produit"
                            placeholder="Selectionner un Produit"
                            onChange={ option => this.handleSelectProducts(option,i)}
                            error={this.state.errors.products[i].return_product_id}
                        />    
                    </TableCell> */}
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={this.state.sale.products[i].display}
                        onChange={option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].return_product_id}
                    />

                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            max={this.state.sale.products[i].max} 
                            onChange={this.handleChange} 
                            value={this.state.sale.products[i].quantity } 
                            name={"prod_-quantity-"+i} 
                            title="Quantité"
                            error={this.state.errors.products[i].quantity}
                            helperText={this.state.sale.products[i].max ? "Disponible : "+ this.state.sale.products[i].max :"" }
                        />
                    </TableCell>
                    {this.state.sale.nature !== "transfer" && 
                        <>
                        <TableCell>
                            <InputText 
                                disabled
                                type="number" 
                                onChange={this.handleChange} 
                                value={this.state.sale.products[i].price} 
                                name={"prod_-price-"+i} 
                                title="Prix"
                                error={this.state.errors.products[i].price}
                                helperText={this.state.sale.products[i].priceR ? "Prix Unitaire Base: "+ this.state.sale.products[i].priceR :"" }
                            />
                        </TableCell>
                        <TableCell >
                            <InputText 
                                type="number" 
                                onChange={this.handleChange} 
                                value={this.state.sale.products[i].priceTotal } 
                                name={"prod_-priceTotal-"+i} 
                                title="Prix Total"
                                error={this.state.errors.products[i].priceTotal}
                                helperText={(this.state.sale.products[i].priceR && this.state.sale.products[i].quantity) ? "Prix Total Base : "+ 
                                (this.state.sale.products[i].priceR * (this.state.sale.products[i].quantity) ):"" }
                            />
                            {/* <div className={"fg-line "+ (this.state.errors.products[i].priceTotal ? "has-error" : "") }>
                                <small className="help-block text-center">
                                {(this.state.sale.products[i].priceR && this.state.sale.products[i].quantity) ? "Prix Total Base : "+ 
                                (this.state.sale.products[i].priceR * (this.state.sale.products[i].quantity) ):"" }</small>
                            </div> */}
                        </TableCell>
                        </>
                    }
                </TableRow>                                        
            )
        }
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the sale
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:[
                    ...this.state.sale.products,{
                    display:{},
                    return_product_id:"",
                    product_ref:"",
                    quantity:"",
                    max:"",
                    price:"",
                    priceR:"",
                    priceTotal:"",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    return_product_id:"",
                    product_ref:"",
                    quantity:"",
                    priceR:"",
                    priceTotal:"",
                }]
            },
            numberProd:this.state.numberProd+1,
            
        })   
    }
    handleDeleteProd = (index) => {
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:[
                    ...this.state.sale.products.slice(0,index),
                    ...this.state.sale.products.slice(index +1),
                ]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products.slice(0,index),
                    ...this.state.errors.products.slice(index +1),   
                ]
            },
            numberProd:this.state.numberProd - 1,
        })   
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" ...

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1], value);
            //Test si quantity 
            if(name === "quantity"){
                if (this.state.sale.products[index].max < value){
                    console.log("[INFO] max is too high ", this.state.sale.products[index].max, value);
                    return
                }
            }
            let cpProducts = this.state.sale.products
            cpProducts[index][name] = value
            if(name === "quantity" || name === "price" || name === "priceTotal") {   
                if(value ==="" || regex.test(value)){// update value only if its a int
                let discount = 0;
                let total = 0;
                cpProducts.map( prod => {
                    if ( prod.priceR && prod.quantity && prod.priceTotal){

                        let addDiscount = (prod.priceR *(prod.quantity)) - prod.priceTotal
                        discount += addDiscount > 0 ? addDiscount : 0
                        total += parseFloat(prod.priceTotal)
                    }
                })               
                cpProducts[index].price = Math.round(cpProducts[index].priceTotal / cpProducts[index].quantity) || cpProducts[index].priceR
                    this.setState({
                        ...this.state,
                        sale:{
                            ...this.state.sale,
                            products:cpProducts,
                            discount,
                            total
                        }
                    })
                }
                
            } else {
                this.setState({
                    ...this.state,
                    sale:{
                        ...this.state.sale,
                        products:cpProducts,
                    }
                })
            }
                    
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [field]:value
                }
            })
        }
    }
    validate = () => {
        let noErrors = true
        let errors = this.state.errors
        const notRequired = ["comments", "transport", "taxes", "client_ref", "sale_paygo_id", "total", "discount"]
        // const validDiscount = await this.validateReduc()
        if(this.state.sale.nature !== "payg"){
            notRequired.push("cli_type", "cli_typeDisplay")
        }

        const sale = Object.assign({}, this.state.sale)
        Object.keys(sale).map( field => {
            console.log(field);
            
            if( isEmpty(sale[field]) && !notRequired.includes(field) ) {// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                sale.products.map((item, j)=>{
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        
                        if(field2 === "max" || field2 === "reduc_max" ){
                            errors.products[j][field2] = ""
                        } else if(field2.startsWith("price") && sale.nature === "transfer"){
                            errors.products[j][field2] = ""
                        } else if(item[field2] === "" || item[field2] === 0 || item[field2] === "0"){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "Stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })

            } else {// not empty
                errors[field] = ""   
            }
        })

        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        })
        if(noErrors){
            this.setState({
                view : (sale.nature !== "transfer" ? "client": "confirm")
            })
        } else {// !VALIDATE
            toast.error("Le formulaire contient des erreurs")
        }
        
        // return noErrors
    }

    validateClient = () => {
        let noErrors = true
        let errors = this.state.errorsClient
        const client = Object.assign({}, this.state.client )

        if(!client.client_paygo_id){

            const notRequired = ["client_address", "client_email", "id"]
            if(this.state.sale.client_ref || this.state.sale.cli_type === "mjb"){ // old client with no phone number
                notRequired.push("client_tel")
            }
            if(this.state.sale.cli_type !== "mjb"){ // not mjb client so no paygoID
                notRequired.push("client_paygo_id")
            }
            
            Object.keys(client).map( field => {

                if( ( isEmpty(client[field]) && !notRequired.includes(field)) ) { // input is empty  
                    noErrors = false
                    errors[field]="Veuillez remplir ce champ"
                } else {// not empty
                    errors[field]=""   
                }
            })
            console.log("[INFO] NOERRORS = ",noErrors);
            console.log("[INFO] VALIDATE, ERRORS = ",errors);
            
            this.setState({
                ...this.state,
                errorsClient : errors
            })
        }

        if(noErrors){
            this.setState({
                view:"confirm",
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
        // return noErrors
    }
    
    handleSelectClient = (idClient, infoClient, option)=>{
        console.log("SELECT HANDLE",{option});

        let value = idClient || (option?.value)
        let infos = infoClient || option?.infos || {}
        
        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                clientDisplay:option,
                client_lastname:infos.client_lastname || "",
                client_firstname:infos.client_firstname || "",
                client_address:infos.client_address || "",
                client_tel:infos.client_tel || "",
                client_email:infos.client_email || "",
                client_city:infos.client_city || "",
                client_country:infos.client_country || "",
                client_paygo_id:infos.client_paygo_id || "",
                id: value,
            },
            sale:{
                ...this.state.sale,
                sale_paygo_id: this.state.sale.cli_type === "mjb" ? value : "",
                client_ref: this.state.sale.cli_type !== "mjb" ? value : "",
            }
        })
    }
    handleSelectClientInfo = (idClient, clientInfo) => {
        if (this.state.client.id === idClient) {
            this.setState({
                ...this.state,
                client: {
                    ...this.state.client,
                    client_address: clientInfo?.adress || this.state.client.client_address,
                    client_tel: clientInfo?.phone || this.state.client.client_tel,
                }
            })
        }
    }

    handleChangeClient =  (e) => {  
        const field = e.target.name
        const value = e.target.value
        
        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                [field]:value,
            }
        })
    }
    handleSubmit = async () => {

        let sale = Object.assign({}, this.state.sale)
        let client = Object.assign({}, this.state.client)

        sale.id = ""
        sale.shop_id = sale.shop
        sale.shop_dest = sale.shopDest
        sale.date = new Date()
        sale.client = client
        sale.transport = parseFloat(sale.transport)                      
        sale.taxes = parseFloat(sale.taxes) 
        sale.discount = parseFloat(sale.discount) 
        for (let i = 0; i < sale.products.length; i++){
            sale.products[i].quantity = parseInt(sale.products[i].quantity)                      
            sale.products[i].price = parseFloat(sale.products[i].priceTotal)     
        }
            
        await this.props.createReturnSale(sale).then(
            e => {
                this.setState({
                    sending: false,
                })
                toast.success("Opération enregistrée avec succès")
                this.clearForms()                        
                this.props.handleClose()
            }
        ).catch(
            e =>{
                this.setState({
                    sending: false,
                })
                toast.error("ERROR "+JSON.stringify(e))
            }
        )              
    }
    clearForms = () => {
        this.setState({
            numberProd:1,
            
            sale:initSale,
            client:initClient,
            // errors?
            errors:initErrors,
            errorsClient:initClient,                
            
        })
    }

    render() {
        const { view } = this.state;
        // console.log("[STATE] NEW SALE FORM ",this.state);
        // console.log("[PROPS] NEW SALE FORM ",this.props);

        let fieldList = [
            {name: "client_lastname", label:"Nom", display:this.state.client.client_lastname},
            {name: "client_firstname", label:"Prénom", display:this.state.client.client_firstname},
            {name: "client_address", label:"Adresse", display:this.state.client.client_address},
            {name: "client_city", label:"Ville", display:this.state.client.client_city},
            {name: "client_country", label:"Pays", display:this.state.client.client_country},
            {name: "client_tel", label:"Téléphone", display:this.state.client.client_tel},
            {name: "client_email", label:"Email", display:this.state.client.client_email},
            {name: "shop", label:"Magasin", display:this.state.sale.shopDisplay.label},
            {name: "nature", label:"Nature", display: this.state.sale.natureDisplay.label},
            {name: "transport", label:"Coût Transport", display:this.state.sale.transport},
            {name:"taxes", label:"Autres Taxes", display:this.state.sale.taxes},        
            {name:"products"},   
            {name:"comments", label:"Commentaires",display:this.state.sale.comments},
            {name:"discount", label:"Réduction Totale", display:this.state.sale.discount},
            {name:"total", label:"Montant Total", display:this.state.sale.total},
        ]
        if (this.state.sale.nature === "transfer") {
            fieldList = [
                {name: "shop", label:"Magasin", display:this.state.sale.shopDisplay.label},
                {name: "shop_dest", label:"Destinataire", display:this.state.sale.shopDestDisplay.label},
                {name: "nature", label:"Nature", display: this.state.sale.natureDisplay.label},
                // {name: "transport", label:"Coût Transport", display:this.state.sale.transport},
                // {name:"taxes", label:"Autres Taxes", display:this.state.sale.taxes},        
                {name:"products"},   
                {name:"comments", label:"Commentaires",display:this.state.sale.comments},
                // {name:"discount", label:"Réduction Totale", display:this.state.sale.discount},
                // {name:"total", label:"Montant Total", display:this.state.sale.total},
            ]
        }
             
        return (
            <React.Fragment>
                {view === "sale" &&
                    <div>
                        <h5>Formulaire Vente occasion</h5>
                        <FormReturnSale 
                            {...this.state} 
                            {...this.props} 
                            handleSelect={this.handleSelect}
                            createAddForm={this.createAddForm}
                            handleAddProd={this.handleAddProd}
                            handleChange={this.handleChange}
                            validate={this.validate}
                            handleClose={this.props.handleClose}
                        />
                    </div>
                }
                {view === "client" &&
                    <PopUp 
                        title="Formulaire Client" 
                        close={() => this.setState({
                            view: "sale", 
                            client:initClient, 
                            client_ref: "",
                            sale_paygo_id: "", 
                        })}
                        submitAction={this.validateClient}
                    >
                        <FormClient 
                            {...this.state} 
                            {...this.props}
                            handleSelectClient={this.handleSelectClient}
                            handleSelectClientInfo={this.handleSelectClientInfo}
                            handleChangeClient={this.handleChangeClient}
                            nosubmit
                            // validateClient={this.validateClient}
                        />

                    </PopUp>
                    
                }
                {view === "confirm" &&
                <PopUp 
                    title="Résumé" 
                    close={() => this.setState({view: "client"})}
                    submitAction={ this.handleSubmit }
                    submitTitle="Valider"     
                >
                    <TableLayout>
                        <TableBody>
                        
                        {fieldList.map( field => {
                            if(this.state.client[field.name]){
                                return (
                                    <TableRow>
                                        <TableCell>{field.label}</TableCell>
                                        <TableCell colSpan={3}>{field.display}</TableCell>
                                    </TableRow>
                                )
                                
                            } else if(this.state.sale[field.name]){
                                if (field.name === "products"){
                                    return this.state.sale.products.map((prod, index)=>(
                                        <TableRow>
                                            <TableCell>{prod.display.label}</TableCell>
                                            <TableCell>{prod.quantity}x{prod.price} {prod.priceR !== parseFloat(prod.price) && <i className="linethrough">{prod.priceR}</i>}</TableCell>
                                            
                                            <TableCell><b>{ prod.priceTotal }</b></TableCell>
                                        </TableRow>
                                    ))
                                } else {
                                    return (
                                        <TableRow>
                                            <TableCell>{field.label}</TableCell>
                                            <TableCell colSpan={3}>{field.display}</TableCell>
                                        </TableRow>
                                    )
                                }
                            } 
                        })

                        }                            
                        </TableBody>
                    </TableLayout>
                </PopUp>
                }
            </React.Fragment>
        );
    }
}

export default Form;